import {
  Box,
  Icon,
  LinkAnchor,
  ModalHeader,
  PrimaryButton,
  Typo,
} from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'
import { Trans } from 'react-i18next'

import {
  TKeyBuilder,
  useWriskTranslation,
} from '../../infrastructure/internationalisation'
import { Scheme } from '../../state/configuration'

export interface PrefillModalFailedProps {
  scheme: Scheme
  tKey: TKeyBuilder
  onSkip: () => void
}

export const PrefillModalFailed: FunctionComponent<PrefillModalFailedProps> = ({
  tKey,
  onSkip,
}) => {
  const { t } = useWriskTranslation()

  const header = (
    <Box
      display='flex'
      alignItems='center'
      width={1}
      columnGap={4}
      justifyContent='flex-start'
    >
      <Icon icon='crossFilled' size='large' />
      <Typo variant='heading' typoSize='xl'>
        {t(tKey('modals', 'fail', 'header'))}
      </Typo>
    </Box>
  )

  const subheader = (
    <Trans
      t={t}
      i18nKey={t(tKey('modals', 'fail', 'subheader'))}
      components={{
        SkipLink: <LinkAnchor onClick={onSkip} />,
      }}
    />
  )

  return (
    <ModalHeader
      header={header}
      subheader={subheader}
      lowerContent={
        <PrimaryButton onClick={onSkip} mt={6}>
          {t(tKey('modals', 'fail', 'actions', 'continue'))}
        </PrimaryButton>
      }
    />
  )
}
